import { render, staticRenderFns } from "./arenda-spatii.vue?vue&type=template&id=368989bf&scoped=true"
import script from "./arenda-spatii.vue?vue&type=script&lang=js"
export * from "./arenda-spatii.vue?vue&type=script&lang=js"
import style0 from "./arenda-spatii.vue?vue&type=style&index=0&id=368989bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368989bf",
  null
  
)

export default component.exports